import { useTranslation } from 'react-i18next';

export type ActiveFilterChipModel = {
  id: string;
  label: string;
  onClear: () => void;
};

interface ActiveFilterChipsProps {
  chips: ActiveFilterChipModel[];
  /** aria-label del contenedor. */
  ariaLabel?: string;
  className?: string;
}

/**
 * Chips de filtros aplicados (clear por chip).
 * Pensado para acompañar FilterSheet en mobile.
 */
export function ActiveFilterChips({ chips, ariaLabel, className = '' }: ActiveFilterChipsProps) {
  const { t } = useTranslation();
  if (chips.length === 0) return null;

  return (
    <div
      role="list"
      aria-label={ariaLabel ?? t('domain.filterSheet.activeFilters')}
      className={`flex flex-wrap gap-2 ${className}`}
    >
      {chips.map((chip) => (
        <span
          key={chip.id}
          role="listitem"
          className="inline-flex h-8 max-w-full items-center gap-1.5 rounded-full border border-teal-500/40 bg-teal-50 px-2.5 text-xs font-semibold text-teal-700 dark:border-teal-400/30 dark:bg-teal-950/40 dark:text-teal-200"
        >
          <span className="truncate">{chip.label}</span>
          <button
            type="button"
            onClick={chip.onClear}
            aria-label={t('domain.filterSheet.removeFilter', { label: chip.label })}
            className="grid h-5 w-5 shrink-0 place-items-center rounded-full text-teal-700 transition hover:bg-teal-100 focus:outline-none focus:ring-2 focus:ring-teal-500 dark:text-teal-200 dark:hover:bg-teal-900"
          >
            ×
          </button>
        </span>
      ))}
    </div>
  );
}
